import React, { Component } from "react";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { Chart } from "react-google-charts";

import Loader from "../../utils/Loader";

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class RevenueChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataLoaded: false,
			options: {
				legend: "none",
				pointSize: 6,
				hAxis: {
					textStyle: {
						fontName: "Arial, Helvetica, sans-serif",
						fontSize: 12
					}
				},
				vAxis: {
					minValue: 0,
					format: "currency"
				},
				height: 300,
				width: "100%",
				chartArea: {
					left: 60,
					width: "90%",
					height: "80%"
				},
				animation: {
					startup: true,
					duration: 200,
					easing: "out"
				},
				colors: ["#15A0C8"],
				areaOpacity: 0.1
			},
			data: [],
			error: ""
		};
	}

	updateState(data) {
		if (!isEmpty(data)) {
			let dataArrays = [];
			let char_spaces = 0;

			dataArrays.push(["Date", "Earned"]);

			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					const item = data[key];
					const total = parseFloat(item.total);

					dataArrays.push([item.date, total]);

					// Calculate char spaces needed for left side axis values
					if (total >= 10000) {
						char_spaces += 2;
					} else if (total >= 1000) {
						char_spaces += 1;
					}
				}
			}

			char_spaces *= 10;

			let chartArea = this.state.options.chartArea;
			chartArea.left += char_spaces;

			this.setState({ dataLoaded: true, data: dataArrays, options: { ...this.state.options, chartArea: chartArea } });
		} else {
			this.setState({ dataLoaded: true });
		}
	}

	componentDidMount() {
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
		return axios
			.get(REACT_APP_API_URL + "summary/revenue", { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200) {
					this.setState({ dataLoaded: true, error: response.data.message });
				} else if (response.data.errors) {
					this.setState({ dataLoaded: true, error: response.data.errors });
				} else {
					this.updateState(response.data);
				}
			})
			.catch(err => {
				this.setState({ dataLoaded: true, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
			});
	}

	render() {
		return (
			<div className="chart_area">
				{this.state.error && (
					<div className="error">
						{Object.keys(this.state.error).map(key => (
							<span key={key}>{this.state.error[key]}</span>
						))}
					</div>
				)}
				{this.state.dataLoaded ? (
					!isEmpty(this.state.data) ? (
						<Chart chartType="AreaChart" options={this.state.options} data={this.state.data} graph_id="AreaChart" width="100%" height="300px" />
					) : (
						<div className="pb2 pt2 instruction centered">No data at this time.</div>
					)
				) : (
					<div className="pt2 pb2 centered">
						<Loader />
					</div>
				)}
			</div>
		);
	}
}

export default RevenueChart;



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/RevenueChart.js